import React from 'react';
import { Alert } from 'react-bootstrap';

import { useTranslation } from '../../../common/hooks/useTranslation';
import { REQUIRED_SURVEY_EMAIL_TAGS } from '../../../common/pokCore/validation/schemas';

import { PlaceholderBadge } from './PlaceholderBadge';

interface PlaceholdersSectionProps {
  placeholders: Array<{
    tag: string;
    description: string;
    required: boolean;
  }>;
  copiedTag: string | null;
  copyToClipboard: (tag: string) => void;
}

export const PlaceholdersSection: React.FC<PlaceholdersSectionProps> = ({
  placeholders,
  copiedTag,
  copyToClipboard,
}) => {
  const { t, tk } = useTranslation('administrationLng');

  return (
    <Alert variant="info" className="mb-4">
      <h5 className="mb-3">
        {t(tk.survey.emailTemplatePlaceholdersDesc)} (
        {t(tk.survey.emailTemplatePlaceholderClickToCopy)})
      </h5>

      <div className="row g-2 gx-5">
        {placeholders.map(placeholder => {
          const isCopied = copiedTag === placeholder.tag;

          return (
            <div key={placeholder.tag} className="col-12 col-md-6">
              <PlaceholderBadge
                tag={placeholder.tag}
                description={placeholder.description}
                isCopied={isCopied}
                onCopy={copyToClipboard}
                isRequired={placeholder.required}
              />
            </div>
          );
        })}
      </div>
      <p className="mt-3">
        <strong>
          {t(tk.survey.emailTemplatePlaceholdersNote, {
            required: REQUIRED_SURVEY_EMAIL_TAGS.join(', '),
          })}
        </strong>
      </p>
    </Alert>
  );
};
